import { Button } from '@mui/material';
import { Grid } from '@mui/material';
import React from 'react';
import LockIcon from '@mui/icons-material/Lock';

const FilterActionButton = ({
  isUserAllowed,
  handleCloseMenu,
  resetFilter,
  handleOnSampleClick,
}: {
  handleCloseMenu: () => void;
  resetFilter: any;
  isUserAllowed: boolean;
  handleOnSampleClick: (plan: string) => void;
}) => {
  return (
    <Grid container justifyContent="space-between">
      <Grid item>
        <Button
          variant="text"
          onClick={() => {
            if (isUserAllowed) {
              resetFilter();
              handleCloseMenu();
            } else {
              handleOnSampleClick('expert');
            }
          }}
        >
          Reset
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          sx={{ color: '#fff' }}
          onClick={() => {
            if (isUserAllowed) {
              handleCloseMenu();
            } else{
              handleOnSampleClick('expert');
            }
          }}
          startIcon={isUserAllowed ? null : <LockIcon />}
        >
          {isUserAllowed ? 'Done' : 'Apply'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FilterActionButton;
